import { classNames } from "../styles/classNames";
import SpinnerIcon from "./SpinnerIcon";

interface LoadingIndicatorProps {
  label: string;
  className?: string;
}

export default function LoadingIndicator({ label, className }: LoadingIndicatorProps) {
  return (
    <div className={classNames("app-loading-indicator flex items-center justify-center gap-2 py-2", className)}>
      <SpinnerIcon />
      <span className="text-sm">{label}</span>
    </div>
  );
}
